import { replaceMessagePlaceholders } from '@src/shared/includes/functions';

import messages from './messages.json';

type EventAccessor = 'Events';
type EventPluralName = 'Events';
type EventSingularName = 'Event';
type EventSlug = 'event';

export type Configuration = {
  accessor: EventAccessor;
  messages: Record<string, any>;
  pluralName: EventPluralName;
  singularName: EventSingularName;
  slug: EventSlug;
};

export const configuration: Configuration = {
  accessor: 'Events',
  messages: {},
  pluralName: 'Events',
  singularName: 'Event',
  slug: 'event',
};

configuration.messages = replaceMessagePlaceholders(messages, configuration.singularName);
